<template>
  <v-form id="Persons" v-model="valid" ref="form">
    <v-text-field
      label="Pełne imię i nazwisko osoby"
      :value="person"
      required
      :rules="[rules.required]"
      @keyup="normalizaPersonName"
      @change="changeName"
    ></v-text-field>

    <!-- <v-layout row justify-space-between>
      <v-flex xs9> -->
    <v-select
      :label="t('Role')"
      v-model="role"
      v-bind:items="roles(cellType)"
      item-text="1"
      item-value="0"
      @input="changeRole"
      :menu-props="{ maxHeight: '400' }"
      required
      :rules="[rules.required]"
    ></v-select>

    <!-- </v-flex> -->

    <!-- <v-flex></v-flex>

      <v-flex xs2>
        <v-text-field :label="t('Cell')" :value='item.cell' disabled></v-text-field>
      </v-flex>
    </v-layout> -->

    <!-- <v-layout row justify-space-between>

      <v-text-field :label="t('From when')" v-model='start' @input="dirty = true"
      :rules="[rules.start]"
      type="date" class="date" xs6></v-text-field>

      <v-text-field :label="t('To when')" v-model='end' @input="dirty = true"
      :rules="[rules.end]" v-show="!isNew" @change="changeEnd"
      type="date" class="date ml-2" xs6></v-text-field>
    </v-layout>

    <label v-if="isAdmin" class="caption mt-2">key: {{item['.key']}}</label><br /> -->
    <v-btn color="primary" @click="validateSave">Dodaj osobę</v-btn>
  </v-form>
</template>

<script>
import { t } from '@/i18n'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { mapStateMutations, mapGettersMutations } from '@/store'

export default {
  props: ['cellProp'],

  async created() {
    await this.$store.dispatch('authorize')
    this.item = { cell: this.cellProp }
  },
  watch: {
    editing(v) {
      if (!v) {
        this.$refs.form.reset()
      }
    },
  },

  computed: {
    ...mapState('assignment', ['rules']),
    ...mapGetters('assignment', ['activeItems', 'isNew', 'props', 'endHint']),
    ...mapGetters(['cell', 'cellType', 'roles', 'roleName', 'readOnly']),
    editing: mapStateMutations('assignment/editing'),
    dirty: mapStateMutations('assignment/dirty'),
    valid: mapStateMutations('assignment/valid'),
    activeTab: mapStateMutations('assignment/activeTab'),
    item: mapStateMutations('assignment/item'),
    person: mapGettersMutations('assignment/person', 'getters'),
    role: mapGettersMutations('assignment/role', 'getters'),
    start: mapGettersMutations('assignment/start', 'getters'),
    end: mapGettersMutations('assignment/end', 'getters'),
    isAdmin() {
      return this.$store.getters.currentUser.displayName === 'Jacek Kolodziejczyk'
    },
  },

  methods: {
    ...mapMutations('assignment', ['edit']),
    ...mapActions('assignment', [
      'back',
      'add',
      'changeName',
      'changeRole',
      'askSetEnd',
      'save',
      'remove',
      'finish',
      'beforeRouteLeave',
    ]),
    validateSave() {
      this.editing = true
      if (this.$refs.form.validate()) {
        this.save()
      } else {
        this.$store.commit('dialog', {
          title: 'Error',
          content: t('Fix errors'),
          buttons: ['OK'],
        })
      }
    },
    normalizaPersonName(e) {
      const start = e.target.selectionStart
      const name = (e.target.value || '')
        .replace(/(\s{2;})/, ' ')
        .replace(/[\wąćęłóńśżźĄĆĘŁÓŃŚŻŹ]+/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase())
      e.target.value = this.person = name
      e.target.setSelectionRange(start, start)
      this.dirty = true
    },
  },
}
</script>
